/**
 * The regions a release date can differ by.
 *
 * Deliberately a short, closed list rather than every country a source knows.
 * The poller stores one set of dates per region in the snapshot, so this list
 * is a storage cost paid on every film — and a picker with two hundred entries
 * is worse than one with six regardless.
 *
 * Shared by the poller (which decides what to store) and the app (which
 * decides what to offer), so the two can never drift apart and leave a
 * selectable region with no data behind it.
 */

export interface Region {
  code: string;
  name: string;
}

export const REGIONS: readonly Region[] = [
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
  { code: 'IE', name: 'Ireland' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
  { code: 'NZ', name: 'New Zealand' },
];

export const REGION_CODES: readonly string[] = REGIONS.map((r) => r.code);

export function regionName(code: string | null): string | null {
  if (!code) return null;
  return REGIONS.find((r) => r.code === code)?.name ?? code;
}

export function isKnownRegion(code: string | null | undefined): code is string {
  return typeof code === 'string' && REGION_CODES.includes(code);
}
